import { LoadableBackground } from '@confluence/loadable';

export const Dialogs = LoadableBackground({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-Dialogs" */ '../src/Dialogs.tsx')).Dialogs,
});
